import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ThemeAssetComponent } from '@partners/themes';
import { BaseButtonComponent } from '../base-button/base-button.component';

@Component({
  selector: 'stroked-button',
  standalone: true,
  template: `
    <button mat-button [disabled]="disabled" [type]="type" (click)="onClick($event)">
      <ng-container *ngIf="iconName">
        <theme-asset [asset]="iconName()" [size]="iconSize()"></theme-asset>
      </ng-container>
      <ng-content></ng-content>
    </button>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'button--stroked'
  },
  exportAs: 'strokedButton',
  imports: [NgIf, MatButtonModule, ThemeAssetComponent]
})
export class StrokedButtonComponent extends BaseButtonComponent {
  constructor() {
    super();
  }

  onClick(event: MouseEvent | TouchEvent) {
    event.stopPropagation();
    event.preventDefault();

    this.click.emit({ event: event, context: this.context });
    this.changeDetector.markForCheck();
  }
}
